import { useTranslation } from "react-i18next";

import ObservationRecommendedInterventionsBar from "@/components/Observation/ObservationRecommendedInterventionsBar";

const ObservationRecommendedInterventionsCell = ({ observation }) => {
  const { t } = useTranslation();

  if (observation.needs_recommendation === false) {
    return t("recommendation:noRecommendations.active");
  }

  if (
    !observation.recommendation_id ||
    !observation?.recommended_interventions.total
  ) {
    return null;
  }

  return <ObservationRecommendedInterventionsBar observation={observation} />;
};

export default ObservationRecommendedInterventionsCell;
